module.exports = __webpack_public_path__ + "img/watch.415a91cd.png";